import { render } from "./Kategori.vue?vue&type=template&id=0cd84130&scoped=true"
import script from "./Kategori.vue?vue&type=script&lang=js"
export * from "./Kategori.vue?vue&type=script&lang=js"

import "./Kategori.vue?vue&type=style&index=0&id=0cd84130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd84130"]])

export default __exports__